<script>
    import {getContext} from 'svelte';

    const printStore = getContext('printStore');

    $: printing = $printStore;
</script>

<slot {printing}>
</slot>